const uri = "/Receivable";

export default uri;
